import React from 'react';



type Props = {
	/** Billing cycle text */
	children: React.ReactNode,
};



const PriceSideNote: React.FC<Props> = (props) => {
	const {
		children,
	} = props;

	return (
		<div className="price-side-note">
			{children}
		</div>
	);
};



export default PriceSideNote;
